import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import SEO from '../components/SEO';

const Privacy = () => {
  const { language, t } = useLanguage();

  const seoData = {
    es: {
      title: 'Política de Privacidad | PASTORIA SERRALTA, S.L.',
      description: 'Política de privacidad de PASTORIA SERRALTA, S.L. Información sobre tratamiento de datos personales conforme al RGPD y LOPDGDD.'
    },
    en: {
      title: 'Privacy Policy | PASTORIA SERRALTA, S.L.',
      description: 'Privacy policy of PASTORIA SERRALTA, S.L. Information about personal data processing in accordance with GDPR and LOPDGDD.'
    }
  };

  return (
    <div className="min-h-screen bg-white" data-testid="privacy-page">
      <SEO 
        title={seoData[language].title}
        description={seoData[language].description}
        url={language === 'es' ? '/privacidad' : '/en/privacy'}
        noindex={false}
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl sm:text-5xl font-bold text-[#363636] mb-8" data-testid="privacy-title">
          {t.privacy.title}
        </h1>
        <div 
          className="prose prose-lg max-w-none text-gray-700"
          dangerouslySetInnerHTML={{ __html: t.privacy.content }}
          data-testid="privacy-content"
        />
      </div>
    </div>
  );
};

export default Privacy;